import {BASE_HOME} from "../../custom/axios/config/Url";
import {addTransactionPayment, getPaymentCustomer} from "./api";

const mapData = (values) => {
    if (!values)
        return [];

    return values?.map((item) => {
        return {
            nameModule: item.nameModule,
            total: item.total,
            unitPrice: item.price,
        };
    });
}

export const payNow = () =>{

    getPaymentCustomer(false).then(r => {
        let transactionBills = mapData(r?.billModules)
        addTransactionPayment({
            transactionBills: transactionBills
        }).then(r => {
            window.open(BASE_HOME + "information-payment/"+r.externalReferenceCode);
        })
    })
}
